















import Vue from "vue";
import Component from "vue-class-component";
import ProfilePageEdit from "./ProfilePageEdit.vue";
import AppHeading from "@/components/AppHeading.vue";
import { authGuard } from "@/router/guards";

@Component({
  name: "ProfilePage",
  beforeRouteEnter: authGuard,
  components: { ProfilePageEdit, AppHeading }
})
export default class ProfilePage extends Vue {}
